/* ──────────────────────────────────────────────────────────────────────────
   An Instagram handle out of whatever was pasted: @name, name, or a profile
   link with anything after the handle, such as /reels/, ?igsh=… or
   ;utm_medium=… (Jay, 2026-10-12). Shared so the add dialog can check each
   line as it is typed, by the same rule the server saves by.
   ────────────────────────────────────────────────────────────────────────── */

const NOT_PROFILES = ["p", "reel", "reels", "tv", "stories", "explore", "accounts", "direct"];

export function handleFrom(raw: string): string | null {
  let text = raw.trim();
  if (!text) return null;
  const link = /^(?:https?:\/\/)?(?:www\.|m\.)?instagram\.com\/(?:_u\/)?([^/?#;&\s]+)/i.exec(text);
  // A bare handle can carry the same tail as a link: name/reels, @name?x=1.
  text = link ? link[1]! : text.split(/[/?#;&]/)[0]!;
  const handle = text.replace(/^@/, "").toLowerCase();
  if (NOT_PROFILES.includes(handle)) return null;
  return /^[a-z0-9._]{1,30}$/.test(handle) ? handle : null;
}
